let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("i5N4N"), load("2Q4bo"), load("jczTu")]).then(() => parcelRequire('bnpc5'));